/**
 * Format datetime for display in UTC timezone
 * Takes a datetime-local string and formats it for user display in UTC
 */
export const formatDateTime = (dateTimeString: string): string => {
  if (!dateTimeString) return '';

  try {
    // If the string already ends with 'Z', use it as-is; otherwise append 'Z' to treat as UTC
    const dateString = dateTimeString.endsWith('Z') ? dateTimeString : `${dateTimeString}Z`;
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return dateTimeString; // Return original string if invalid
    }

    // Format as UTC date and time
    return date.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'UTC',
    });
  } catch (error) {
    console.warn('Failed to format datetime:', error);

    return dateTimeString; // Return original string if formatting fails
  }
};
